// import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { I18n } from 'react-redux-i18n';

export const useI18n = (namespace) => {
  // const i18n = useSelector(state => state.i18n);
  const translate = useCallback((key) => I18n.t(namespace ? (namespace + '.' + key) : key), [namespace]);
  return { translate };
}
